import { Navigate, useParams } from "react-router-dom";

import { ErrorState, Loading } from "../../components/WorkspacePrimitives";
import { useAgentRun } from "../api/e2e";
import { canonicalRunDestination } from "../lib/runRoutes";

export default function AgentRunRedirect() {
  const { runId = "" } = useParams<{ runId: string }>();
  const query = useAgentRun(runId);

  if (query.isPending && !query.data) {
    return <Loading label="Opening company model…" />;
  }
  if (query.error && !query.data) {
    return <ErrorState error={query.error} onRetry={() => query.refetch()} />;
  }
  const run = query.data;
  if (!run) return null;

  return <Navigate to={canonicalRunDestination(run)} replace />;
}
